<template>
  <el-dialog title="生产组装工序" :visible.sync="visible" width="500px" @close="close">
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="组装开工数量" prop="assembleStartQty">
        <el-input-number v-model="form.assembleStartQty" :min="0" placeholder="请输入组装开工数量"/>
      </el-form-item>
      <el-form-item label="组装工位数量" prop="assembleStationQty">
        <el-input-number v-model="form.assembleStationQty" :min="0" placeholder="请输入组装工位数量"/>
      </el-form-item>
      <el-form-item label="组装完工数量" prop="completeQty">
        <el-input-number v-model="form.completeQty" :min="0" placeholder="请输入组装完工数量"/>
      </el-form-item>
      <el-form-item label="组装线别" prop="assembleLineName">
        <el-input v-model="form.assembleLineName" placeholder="请输入组装线别"/>
      </el-form-item>
      <el-form-item label="工序" prop="station">
        <el-input v-model="form.station" placeholder="请输入工序"/>
      </el-form-item>
      <el-form-item label="生产订单号" prop="productionNo">
        <el-input v-model="form.productionNo" placeholder="请输入生产订单号"/>
      </el-form-item>
      <el-form-item label="是否完工" prop="isEnd">
        <el-radio-group v-model="form.isEnd">
          <el-radio :label="false">否</el-radio>
          <el-radio :label="true">是</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "ProductionAssembleEdit",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        assembleStartQty: 0,
        assembleStationQty: 0,
        completeQty: 0,
        assembleLineName: '',
        station: '',
        productionNo: '',
        isEnd: 0
      }
    };
  },
  watch: {
    data: {
      handler(newVal) {
        this.form = Object.assign({}, newVal);
      },
      immediate: true
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
      this.$refs.form.resetFields();
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.form);
        }
      });
    }
  }
};
</script>